<template>
  <v-container fluid>
    <v-tab-item class="pb-0" eager>
      <first-tab @stepReleased="$emit('step-observer', { step: 0, complete: $event })" />
    </v-tab-item>
    <v-tab-item class="pb-0" eager>
      <second-tab @stepReleased="$emit('step-observer', { step: 1, complete: $event })" />
    </v-tab-item>
  </v-container>
</template>
  
<script>
  export default {
    components: {
      FirstTab: () => import('@/components/obrigacoesEspeciais/tabs/FirstTab.vue'),
      SecondTab: () => import('@/components/obrigacoesEspeciais/tabs/SecondTab.vue')
    },

    emits: ['step-observer'],

    methods: {
      exportData() {
        const vuexData = this.$store.state.obrigacoesEspeciais;

        return {
          id: this.$route.params.id ? this.$route.params.id : null,
          titulo: vuexData.titulo,
          data_base: vuexData.dataBase,
          data_projetada: vuexData.dataProjetada,
          taxa_media_dep: vuexData.taxaMediaDep,
          possui_devolucoes: vuexData.possuiDevolucoes,
          possui_kit: vuexData.possuiKit,
          percentuais: JSON.stringify(vuexData.percentuais),
          valores: JSON.stringify(vuexData.valores),
          files: JSON.stringify(vuexData.uploadedFiles),
          arquivo_delimitador: vuexData.arquivoDelimitador,
          arquivo_involucro: vuexData.arquivoInvolucro,
          arquivo_escape: vuexData.arquivoEscape
        };
      }
    }
  };
</script>